import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { toastr } from "react-redux-toastr";
import { Table as BootstrapTable } from "react-bootstrap";
import { FiCopy, FiEdit2, FiTrash2 } from "react-icons/fi";
import DatePicker from "components/Shared/DatePicker";
import moment from "moment";
import { showModal, hideModal } from "actions/modalActions";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import "./EmployeeCustomFields.scss";
import { withTranslation } from "react-i18next";

class EmployeeCustomFields extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		// console.log(this.props.employee);

		const employee = this.props.employee;
		this.state = {
			employee,
			hasChanged: false,
			isMe: this.props.employee.id === this.props.user.id,
			errors: {},
			error_footer: "",
			custom_fields_list: this.getCustomFieldsList() || []
		};

		this.valueInputs = {};

		this.closeModal = this.closeModal.bind(this);
	}

	componentDidUpdate(prevProps) {
		// Si cambian los custom_fields en los props, actualizar el estado
		if (this.props.custom_fields !== prevProps.custom_fields) {
			this.setState({
				custom_fields_list: this.getCustomFieldsList() || []
			});
		}
	}

	closeModal() {
		this.props.hideModal();
	}

	getCustomFieldsList = () => {
		const { custom_fields } = this.props;
		const custom_fields_list = [];
		const existing_custom_fields = this.props.employee.custom_fields_response || [];

		custom_fields && custom_fields.map((custom_field) => {
			const cfield_employee = {
				value: "",
				custom_field,
			}

			if (existing_custom_fields.length > 0) {
				const existing_field = existing_custom_fields.find(cf => cf.custom_field.id === custom_field.id);

				if (existing_field) {
					cfield_employee.value = existing_field.value;
				}
			}

			custom_fields_list.push(cfield_employee);
			return true;
		});

		return custom_fields_list;
	}

	handleChange = (event) => {
		const { employee } = this.state;

		const key = event.target.id;
		const value = event.target.value;

		this.setState({
			prevEmployee: employee,
			employee: {
				...employee,
				[key]: value,
			},
		});
	};

	handleChangeCustomField = (event, cfield_employee) => {
		const { custom_fields_list } = this.state;

		const value = event.target.value;

		// Auto-ajustar altura para campos de texto ampliado
		if (event.target && event.target.tagName === "TEXTAREA") {
			const textarea = event.target;
			const baseHeight = 34; // altura aproximada de un input normal
			textarea.style.height = "auto";
			const newHeight = Math.max(baseHeight, textarea.scrollHeight);
			textarea.style.height = `${newHeight}px`;
		}
		var hasChanged = false;

		custom_fields_list.map((cf) => {
			if (cf.custom_field.id === cfield_employee.custom_field.id) {
				cf.value = value;
				hasChanged = true;
			}
			return true;
		});

		this.setState({
			hasChanged,
			custom_fields_list
		});
	};

	handleBlur = async () => {
		if (this.state.hasChanged) {
			this.saveEmployee();
		}
	};

	prepareCustomFieldsForSubmit = () => {
		const { custom_fields_list } = this.state;
		const custom_fields_submit_list = [];
		custom_fields_list.map((cf) => {
			if (cf.value) {
				const new_cf = {
					custom_field_id: cf.custom_field.id,
					value: cf.value,
				}

				custom_fields_submit_list.push(new_cf);
			}
			return true
		});
		return custom_fields_submit_list;
	};


	saveEmployee = async () => {
		const { employee } = this.state;

		// preparar custom field ids
		employee.custom_fields = this.prepareCustomFieldsForSubmit();

		const response = await employeesService.update(employee);

		if (response.ok) {
			toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
			this.setState({
				hasChanged: false,
				errors: {},
			});
		} else {
			this.setState({
				hasChanged: false,
				errors: errorFormating(response),
			});
		}
	};

	checkValidField = (name) => {
		return (
			this.state.errors[name] !== undefined && this.state.errors[name] !== ""
		);
	};

	focusField = (customFieldId) => {
		// Primero intentar localizar el input real en el DOM (especialmente para DatePicker)
		const domInput = document.querySelector(
			`[data-custom-field-id="${customFieldId}"] input`
		);

		if (domInput) {
			domInput.focus();
			if (typeof domInput.click === "function") {
				domInput.click();
			}
			if (typeof domInput.select === "function") {
				domInput.select();
			}
			return;
		}

		// Fallback: usar la referencia almacenada (para inputs normales)
		const input = this.valueInputs[customFieldId];
		if (input) {
			input.focus();
			if (input.select) {
				input.select();
			}
			if (typeof input.click === "function") {
				input.click();
			}
		}
	};

	handleCopyValue = async (employee_custom_field) => {
		const value = employee_custom_field.value;
		if (!value) return;

		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(value);
				toastr.success(this.props.t("customFields.employee.copied"), this.props.t("customFields.employee.copiedValue"));
			}
		} catch (e) {
			// Ignorar errores silenciosamente
		}
	};

	handleClearValue = (employee_custom_field) => {
		const { custom_fields_list } = this.state;
		const updated = custom_fields_list.map((cf) => {
			if (cf.custom_field.id === employee_custom_field.custom_field.id) {
				return { ...cf, value: "" };
			}
			return cf;
		});

		this.setState(
			{
				custom_fields_list: updated,
				hasChanged: true,
			},
			() => {
				this.saveEmployee();
			}
		);
	};

	renderCustomFieldValue = (employee_custom_field) => {
		const custom_field = employee_custom_field.custom_field;
		const value = employee_custom_field.value;
		const type =
			custom_field.type === "TEXT_AREA"
				? "textarea"
				: custom_field.type.toLowerCase();

		if (type === "date") {
			return (
				<div
					className={`form-group form-date ${
						value === "" ? "empty" : ""
					}`}
					data-custom-field-id={custom_field.id}
					onClick={() => this.focusField(custom_field.id)}
				>
					<DatePicker
						selected={value ? moment(value).toDate() : null}
						onChange={(date) => {
							const syntheticEvent = {
								target: {
									value: date
										? moment(date).format("YYYY-MM-DD")
										: "",
								},
							};
							this.handleChangeCustomField(
								syntheticEvent,
								employee_custom_field
							);
						}}
						onBlur={this.handleBlur}
						className="form-control custom-field-control"
						placeholderText="dd/mm/aaaa"
						ref={(el) => {
							if (el) {
								this.valueInputs[custom_field.id] = el.input || el;
							}
						}}
					/>
				</div>
			);
		}

		// Texto normal, número o texto ampliado (textarea)
		const commonProps = {
			className: "form-control custom-field-control",
			value,
			onChange: (e) =>
				this.handleChangeCustomField(e, employee_custom_field),
			onBlur: this.handleBlur,
			placeholder: custom_field.name,
			ref: (el) => {
				if (el) {
					this.valueInputs[custom_field.id] = el;
					// Ajuste inicial de altura para textareas con varias líneas
					if (type === "textarea") {
						const baseHeight = 34;
						el.style.height = "auto";
						const newHeight = Math.max(baseHeight, el.scrollHeight);
						el.style.height = `${newHeight}px`;
					}
				}
			},
		};

		return (
			<div
				className={`form-group ${value === "" ? "empty" : ""}`}
				onClick={() => this.focusField(custom_field.id)}
			>
				{type === "textarea" ? (
					<textarea
						{...commonProps}
						rows={1}
						style={{ resize: "none", overflow: "hidden" }}
					/>
				) : (
					<input
						{...commonProps}
						type={type === "number" ? "text" : type}
					/>
				)}
			</div>
		);
	};

	getContent = () => {
		const { custom_fields_list } = this.state;

		return (
			<div className="table-responsive">
				<BootstrapTable
					responsive
					hover
					className="times-table employee-custom-fields-table"
				>
					<thead>
						<tr>
							<th style={{ width: "20%", padding: "6px 8px" }}>{this.props.t("customFields.employee.headerField")}</th>
							<th style={{ width: "60%", padding: "6px 8px" }}>{this.props.t("customFields.employee.headerValue")}</th>
							<th
								style={{ width: "36px", padding: "6px 4px" }}
								className="employee-custom-field-actions-header text-center"
							>
								{this.props.t("customFields.employee.headerActions")}
							</th>
						</tr>
					</thead>
					<tbody>
						{custom_fields_list.map((employee_custom_field) => {
							const custom_field = employee_custom_field.custom_field;

							return (
								<tr key={custom_field.id}>
									<td
										className="employee-custom-field-label"
										style={{ padding: "4px 8px", verticalAlign: "middle" }}
									>
										{custom_field.name}
									</td>
									<td
										className="employee-custom-field-value-cell"
										style={{ padding: "4px 8px", verticalAlign: "middle" }}
									>
										{this.renderCustomFieldValue(
											employee_custom_field
										)}
									</td>
									<td
										className="employee-custom-field-actions text-center"
										style={{
											width: "36px",
											whiteSpace: "nowrap",
											padding: "4px 4px",
											verticalAlign: "middle",
										}}
									>
										<button
											type="button"
											className="btn btn-light btn-sm mr5"
											onClick={() =>
												this.handleCopyValue(
													employee_custom_field
												)
											}
										>
											<FiCopy />
										</button>
										<button
											type="button"
											className="btn btn-light btn-sm mr5"
											onClick={() =>
												this.focusField(custom_field.id)
											}
										>
											<FiEdit2 />
										</button>
										<button
											type="button"
											className="btn btn-light btn-sm"
											onClick={() =>
												this.handleClearValue(
													employee_custom_field
												)
											}
										>
											<FiTrash2 />
										</button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</BootstrapTable>
			</div>
		);
	};

	render() {
		const { custom_fields_list } = this.state;

		return (
			<>
				{custom_fields_list.length === 0
					? this.props.t("customFields.employee.noFields")
					: this.getContent()}


				{this.state.error_footer && (
					<div
						className="alert alert-danger alert-dismissible fade show mt15"
						role="alert"
					>
						{this.state.error_footer}
					</div>
				)}

				{this.state.errors && this.state.errors.general && (
					<div
						className="alert alert-danger alert-dismissible fade show mt15"
						role="alert"
					>
						{this.state.errors.general}
					</div>
				)}
			</>);
	}
}


const mapStateToProps = (reducers) => {
	return {
		...reducers.customFieldsReducer,
		user: reducers.authReducer.user,
	}
};


const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

// export default connect(mapStateToProps, mapDispatchToProps)(EmployeeInfo);
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
	withTranslation()
)(EmployeeCustomFields);
